import { Icon, IconRef } from "@components/ui/Icon"
import { tv } from "@utils/tw"
import { Link } from "eddev/routing"
import { RecommendedLink } from "../useSearchResults"
import { useSearchInput } from "../useSearchInput"

export function SearchResultLink(props: RecommendedLink) {
  const searchInput = useSearchInput()

  let leftIcon: IconRef = "search"
  let rightIcon: IconRef = "search"

  if (props.type === "link") {
    if (props.external) {
      leftIcon = "externalLink"
      rightIcon = "externalLink"
    } else {
      leftIcon = "link"
      rightIcon = "chevronRight"
    }
  }

  const styles = createStyles({})

  return (
    <Link
      data-search-item
      href={props.type === "link" ? props.link : "/search?q=" + props.term}
      target={props.type === "link" && props.external ? "_blank" : null}
      onClick={(e) => {
        if (props.type === "search" && !e.metaKey && !e.shiftKey && !e.ctrlKey) {
          searchInput.set(props.term)
          // e.preventDefault()
        }
      }}
      className={styles.base()}
      data-mixpanel-suggestion-type="Link"
    >
      <Icon name={leftIcon} className={styles.leftIcon()} />
      <span className={styles.label()}>{props.label}</span>
      <Icon name={rightIcon} className={styles.rightIcon()} />
    </Link>
  )
}

const createStyles = tv({
  base: [
    "type-ui-m search-result-link rounded-[12px] min-w-0 min-h-control ",
    "flex items-center gap-[8px] px-[10px] mx-[-10px]",
    "[&[data-search-selected]]:bg-bg-low hover:bg-bg-low scroll-my-[80px]",
    "[.full-results_&]:px-[12px]",
  ],
  slots: {
    leftIcon: "[.small-results_&]:hidden ml-[-8px]",
    rightIcon: "mr-[-4px] [.full-results_&]:hidden",
    label: "flex-1",
  },
})
